import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { PropertyBottomCarouselWrapper } from './property-bottom-carousel-wrapper';

export const SUVRPropertyBottomCarouselWrapper: React.FunctionComponent = () => (
  <Experiment name="PWA_Similar_Properties_on_PDP_SUVR">
    <ExperimentControl />
    <ExperimentVariant bucket={1}>
      <PropertyBottomCarouselWrapper />
    </ExperimentVariant>
  </Experiment>
);
